<template>
    <div>
        <div class="col-md-12 col-lg-12 revenue-report">
            <div>
                <div style="display: flex; justify-content: space-between">
                    <h2>Details</h2>
                    <div class="text-right detail-control-panel">
                        <button v-on:click="setCollapsedForAll(false)" class="btn">Expand all</button>
                        <button v-on:click="setCollapsedForAll(true )" class="btn">Collapse all</button>
                        <button v-on:click="exportToCSV()" class="btn">Export to CSV</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-hover">
                        <tbody>
                            <tr>
                                <th colspan="7"><h2>{{dateFrom}} - {{dateTo}}</h2></th>
                            </tr>
                            <tr>
                                <th style="max-width:50px">Company ID</th>
                                <th>Employer</th>
                                <th>Budget</th>
                                <th>Gross spend</th>
                                <th>Billable amount</th>
                                <th style="text-align:right">Net Invoice</th>
                            </tr>
                            <template v-for="(statusGroup) in groupedData">
                                <tr class="statusGroupHeadline">
                                    <th colspan="2">
                                        <span v-on:click="statusGroup.collapsed = !statusGroup.collapsed"
                                              :class="['glyphicon', statusGroup.collapsed ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up']"></span>
                                        {{statusGroup.groupName}}
                                    </th>
                                    <th>{{usNum(statusGroup.sum.budget)}}</th>
                                    <th>{{usNum(statusGroup.sum.currentCost)}}</th>
                                    <th>{{usNum(statusGroup.sum.billableAmount)}}</th>
                                    <th class="text-right">{{usNum(statusGroup.sum.netInvoice)}}</th>
                                </tr>
                                <template v-if="!statusGroup.collapsed" v-for="(agencyGroup) in statusGroup.data">
                                    <tr class="agencyGroupHeadline">
                                        <th colspan="2">
                                            <span v-on:click="agencyGroup.collapsed = !agencyGroup.collapsed"
                                                  :class="['glyphicon', agencyGroup.collapsed ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up']"></span>
                                            {{agencyGroup.groupName}}
                                        </th>
                                        <th>{{usNum(agencyGroup.sum.budget)}}</th>
                                        <th>{{usNum(agencyGroup.sum.currentCost)}}</th>
                                        <th>{{usNum(agencyGroup.sum.billableAmount)}}</th>
                                        <th class="text-right">{{usNum(agencyGroup.sum.netInvoice)}}</th>
                                    </tr>
                                    <tr v-if="!agencyGroup.collapsed" v-for="r in agencyGroup.data">
                                        <td style="text-align:right">{{r.employerId}}</td>
                                        <td><div class="truncate" style="width: 200px" :title="r.employerName">{{r.employerName}}</div></td>
                                        <td>{{getBudget(r.budget)}}</td>
                                        <td>{{usNum(r.currentCost)}}</td>
                                        <td>{{getBudget(r.billableAmount)}}</td>
                                        <td class="text-right">{{usNum(r.netInvoice)}}</td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'reportData', 'dateFrom', 'dateTo', 'salesmenList', 'filters', 'filterMode'
        ],
        data() {
            return {
                groupedData: [],
            };
        },
        methods: {
            setCollapsedForAll(isCollapsed){
                _.forEach(this.groupedData, groups => {
                    groups.collapsed = isCollapsed;
                    _.forEach(groups.data, group => {
                        group.collapsed = isCollapsed;
                    });
                });
            },
            usNum(number){
                if(!number){
                    return null;
                }
                return Math.round(parseFloat(number) || 0).toLocaleString('US');
            },
            getBudget(budget, formatted = true) {
                return budget >= 999999.00 ? 'Unlimited' : (formatted ? this.usNum(budget) : budget);
            },
            exportToCSV(){
                const rows = [['Company ID', 'Employer', 'Agency name', 'Dates range', 'Budget', 'Gross spend', 'Billable Amount', 'Net Invoice']];
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += rows.join(",") + "\r\n";
                _.forEach(this.reportData, r => {
                    var rowArray = [
                        r.employerId,
                        r.employerName.replace(/,/g, ''),
                        r.agencyName,
                        r.from + ' - ' + r.to,
                        this.getBudget(r.budget, false),
                        r.currentCost,
                        this.getBudget(r.billableAmount, false),
                        r.netInvoice
                    ];
                    var row = rowArray.join(",");
                    csvContent += row + "\r\n";
                });
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', 'boardRevenue.csv');
                document.body.appendChild(link); // Required for FF
                link.click();
                document.body.removeChild(link);
            },
        },
        mounted: function(){
            if(!this.filterMode){
                this.filterMode = 'byMonth';
            }

            var allGroup = {
                groupName: 'All',
                data: [],
                collapsed: false,
                sum: {
                    budget: 0,
                    currentCost: 0,
                    billableAmount: 0,
                    netInvoice: 0,
                }
            };
            this.groupedData.push(allGroup);
            _.forEach(this.reportData, r => {
                allGroup.data.push(r);
                allGroup.sum.budget += (parseFloat(r.budget) >= 999999.0 ? 0 : parseFloat(r.budget));
                allGroup.sum.currentCost += parseFloat(r.currentCost);
                allGroup.sum.billableAmount += (parseFloat(r.billableAmount) >= 999999.0 ? 0 : parseFloat(r.billableAmount));
                allGroup.sum.netInvoice += parseFloat(r.netInvoice);
            });

            var agenciesGroups = [];
            _.forEach(allGroup.data, r => {
                var v = r.agencyName;
                v = v || 'No agency';
                var agencyGroup = _.find(agenciesGroups, i => i.groupName == v)
                if(!agencyGroup){
                    agencyGroup = {
                        groupName: v,
                        data: [],
                        collapsed: false,
                        sum: {
                            budget: 0,
                            currentCost: 0,
                            billableAmount: 0,
                            netInvoice: 0,
                        }
                    };
                    agenciesGroups.push(agencyGroup);
                }
                agencyGroup.data.push(r);
                agencyGroup.sum.budget += (parseFloat(r.budget) >= 999999.0 ? 0 : parseFloat(r.budget));
                agencyGroup.sum.currentCost += parseFloat(r.currentCost);
                agencyGroup.sum.billableAmount += (parseFloat(r.billableAmount) >= 999999.0 ? 0 : parseFloat(r.billableAmount));
                agencyGroup.sum.netInvoice += parseFloat(r.netInvoice);
            });
            _.forEach(agenciesGroups, ar => {
                ar.data = _.sortBy(ar.data, 'employerName');
            });
            allGroup.data = agenciesGroups;
            allGroup.data = _.sortBy(allGroup.data, 'groupName');
        }
    }
</script>

<style scoped>
.revenue-report {
    align-items: stretch;
    margin-top: 20px;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.revenue-report .detail-control-panel {
    margin: 0 0 20px 0;
}

.revenue-report .statusGroupHeadline th {
    background: lightblue;
    font-size: 18px;
}

.revenue-report .agencyGroupHeadline th {
    background: lightcyan;
    font-size: 15px;
    padding-left: 30px;

}
</style>